import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft } from "lucide-react";

export default function Users() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [pwd, setPwd] = useState({});

  useEffect(() => {
    if (user && user.role !== "admin") navigate("/");
  }, [user, navigate]);

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => {
    load();
  }, []);

  const change = async (u) => {
    const p = pwd[u.username] || "";
    if (p.length < 3) return toast.error("Password too short (min 3)");
    try {
      await api.post(`/users/${encodeURIComponent(u.username)}/password`, { password: p });
      toast.success(`Password updated for ${u.username}`);
      setPwd({ ...pwd, [u.username]: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Update failed");
    }
  };

  return (
    <div className="pos-shell">
      <div className="pos-titlebar">
        <span>User Management</span>
        <div className="right">
          <button className="title-btn" onClick={() => navigate("/")} data-testid="back-pos">
            <ArrowLeft size={13} style={{ display: "inline", marginRight: 4 }} />
            Back to POS
          </button>
        </div>
      </div>
      <div style={{ flex: 1, overflow: "auto", padding: 16, maxWidth: 620 }}>
        <div style={{ background: "#fff", border: "1px solid var(--pos-line)" }}>
          <table className="items-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Name</th>
                <th>Role</th>
                <th>New Password</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.username} data-testid={`user-${u.username}`}>
                  <td>{u.username}</td>
                  <td>{u.name}</td>
                  <td>{u.role}</td>
                  <td>
                    <Input
                      type="password"
                      value={pwd[u.username] || ""}
                      onChange={(e) => setPwd({ ...pwd, [u.username]: e.target.value })}
                      data-testid={`pwd-${u.username}`}
                      style={{ height: 30 }}
                    />
                  </td>
                  <td>
                    <button
                      className="title-btn"
                      onClick={() => change(u)}
                      data-testid={`set-pwd-${u.username}`}
                    >
                      Update
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
